/**
 * Main JavaScript file
 */

import './video-trigger.js';
import './cf7-popups.js';

document.addEventListener('DOMContentLoaded', function() {
    console.log('WS Theme loaded');

    // Global throttled Locomotive update helper
    (function(){
        try {
            var scheduled = false;
            function locoUpdate(){
                if (scheduled) return;
                scheduled = true;
                requestAnimationFrame(function(){
                    scheduled = false;
                    try {
                        if (window.wsScroll && typeof window.wsScroll.update === 'function') {
                            window.wsScroll.update();
                        }
                    } catch (e) {}
                });
            }
            window.wsLocoUpdate = locoUpdate;
            // Optional: listen to custom mutation events from widgets
            window.addEventListener('ws:swiper-mutated', locoUpdate);
        } catch (e) {}
    })();
    // Offcanvas burger menu
    (function(){
        var burger = document.querySelector('.burger');
        var offcanvas = document.getElementById('offcanvas-menu');
        if (!burger || !offcanvas) return;

        function openMenu(){
            offcanvas.setAttribute('aria-hidden', 'false');
            burger.classList.add('is-active');
            burger.setAttribute('aria-expanded', 'true');
            try { if (window.wsLocoUpdate) window.wsLocoUpdate(); } catch (e) {}
        }
        function closeMenu(){
            offcanvas.setAttribute('aria-hidden', 'true');
            burger.classList.remove('is-active');
            burger.setAttribute('aria-expanded', 'false');
            try { if (window.wsLocoUpdate) window.wsLocoUpdate(); } catch (e) {}
        }
        function toggleMenu(){
            var hidden = offcanvas.getAttribute('aria-hidden') !== 'false';
            hidden ? openMenu() : closeMenu();
        }

        burger.addEventListener('click', toggleMenu);

        offcanvas.addEventListener('click', function(e){
            var target = e.target;
            if (!target) return;
            if (target.hasAttribute('data-offcanvas-close')) {
                closeMenu();
            }
        });

        document.addEventListener('keydown', function(e){
            if (e.key === 'Escape') closeMenu();
        });
    })();

    // Custom select dropdowns
    (function(){
        var globalAttached = false;

        function initCustomSelects(context) {
            var root = context || document;
            var selects = Array.prototype.slice.call(root.querySelectorAll('[data-custom-select]'));
            if (!selects.length) return;

            function closeAll(except) {
                selects.forEach(function(select){
                    if (except && select === except) return;
                    if (!select.classList.contains('is-open')) return;
                    select.classList.remove('is-open');
                    var trigger = select.querySelector('[data-custom-select-trigger]');
                    if (trigger) {
                        trigger.setAttribute('aria-expanded', 'false');
                    }
                });
            }

            selects.forEach(function(select){
                if (select.dataset.customSelectReady) return;
                select.dataset.customSelectReady = '1';

                var trigger = select.querySelector('[data-custom-select-trigger]');
                var list = select.querySelector('[data-custom-select-list]');
                var input = select.querySelector('input[type="hidden"]:not([data-area-min]):not([data-area-max])');
                var textEl = select.querySelector('.hero-search__select-text');
                var options = select.querySelectorAll('[data-custom-select-option]');
                if (!trigger || !list || !textEl) return;

                var inputMin = select.querySelector('input[data-range-min]');
                var inputMax = select.querySelector('input[data-range-max]');
                var isRangeSelect = select.hasAttribute('data-custom-select-range') && inputMin && inputMax;

                var areaMinHidden = select.querySelector('input[data-area-min]');
                var areaMaxHidden = select.querySelector('input[data-area-max]');
                var areaInputMin = select.querySelector('input[data-area-input-min]');
                var areaInputMax = select.querySelector('input[data-area-input-max]');
                var isAreaSelect = select.hasAttribute('data-custom-select-area') && areaMinHidden && areaMaxHidden && areaInputMin && areaInputMax;

                if (!isRangeSelect && !isAreaSelect && !input) return;

                function setValue(value, label) {
                    if (input) input.value = value;
                    textEl.textContent = label;
                    options.forEach(function(option){
                        var optionValue = option.getAttribute('data-value') || '';
                        option.setAttribute('aria-selected', optionValue === value ? 'true' : 'false');
                    });
                }

                function setRangeValue(minVal, maxVal, label) {
                    inputMin.value = minVal || '';
                    inputMax.value = maxVal || '';
                    textEl.textContent = label;
                    options.forEach(function(option){
                        var om = option.getAttribute('data-min');
                        var ox = option.getAttribute('data-max');
                        var optMin = om !== null && om !== undefined ? om : '';
                        var optMax = ox !== null && ox !== undefined ? ox : '';
                        option.setAttribute('aria-selected', (optMin === (minVal || '') && optMax === (maxVal || '')) ? 'true' : 'false');
                    });
                }

                function getAreaLabel() {
                    var minV = (areaInputMin && areaInputMin.value) ? parseFloat(String(areaInputMin.value).replace(',', '.')) : 0;
                    var maxV = (areaInputMax && areaInputMax.value) ? parseFloat(String(areaInputMax.value).replace(',', '.')) : 0;
                    var areaPlaceholder = select.getAttribute('data-area-placeholder') || 'Powierzchnia';
                    if (minV <= 0 && maxV <= 0) return areaPlaceholder;
                    var parts = [];
                    if (minV > 0) parts.push(String(Math.round(minV)));
                    parts.push('–');
                    if (maxV > 0) parts.push(String(Math.round(maxV)));
                    return parts.join(' ') + ' m²';
                }

                function syncAreaFromInputs() {
                    var minV = areaInputMin.value.replace(',', '.');
                    var maxV = areaInputMax.value.replace(',', '.');
                    areaMinHidden.value = minV ? minV : '';
                    areaMaxHidden.value = maxV ? maxV : '';
                    textEl.textContent = getAreaLabel();
                }

                trigger.addEventListener('click', function(e){
                    e.preventDefault();
                    var isOpen = select.classList.toggle('is-open');
                    trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
                    if (isOpen) {
                        closeAll(select);
                    }
                });

                if (isAreaSelect) {
                    list.addEventListener('click', function(e) { e.stopPropagation(); });
                    ['input', 'change'].forEach(function(ev){
                        if (areaInputMin) areaInputMin.addEventListener(ev, syncAreaFromInputs);
                        if (areaInputMax) areaInputMax.addEventListener(ev, syncAreaFromInputs);
                    });
                } else {
                    options.forEach(function(option){
                        option.addEventListener('click', function(e){
                            e.preventDefault();
                            var label = (option.textContent || '').trim();
                            if (isRangeSelect) {
                                var minVal = option.getAttribute('data-min');
                                var maxVal = option.getAttribute('data-max');
                                setRangeValue(minVal !== null && minVal !== undefined ? minVal : '', maxVal !== null && maxVal !== undefined ? maxVal : '', label);
                            } else {
                                var value = option.getAttribute('data-value') || '';
                                setValue(value, label);
                            }
                            select.classList.remove('is-open');
                            trigger.setAttribute('aria-expanded', 'false');
                        });
                    });
                }
            });

            if (!globalAttached) {
                globalAttached = true;
                document.addEventListener('click', function(e){
                    if (!e.target.closest('[data-custom-select]')) {
                        closeAll();
                    }
                });
                document.addEventListener('keydown', function(e){
                    if (e.key === 'Escape') {
                        closeAll();
                    }
                });
            }
        }

        try { window.wsInitCustomSelects = initCustomSelects; } catch (e) {}
        initCustomSelects(document);
    })();


    // Headroom integration
    (function(){
        try {
            var header = document.querySelector('#masthead');
            if (!header) return;

            // When Locomotive is absent, use native Headroom if available
            if (window.Headroom && !window.LocomotiveScroll) {
                var headroom = new window.Headroom(header, {
                    tolerance: { up: 5, down: 0 },
                    offset: 80,
                    classes: {
                        initial: 'headroom',
                        pinned: 'headroom--pinned',
                        unpinned: 'headroom--unpinned',
                        top: 'headroom--top',
                        notTop: 'headroom--not-top',
                        bottom: 'headroom--bottom',
                        notBottom: 'headroom--not-bottom'
                    }
                });
                headroom.init();
                return;
            }

            // When Locomotive is present, emulate Headroom using its scroll events
            var attached = false;
            function attachToScroll(scroll){
                if (!scroll || typeof scroll.on !== 'function' || attached) return;
                attached = true;
                var lastY = 0;
                var ticking = false;
                var toleranceUp = 5;
                var toleranceDown = 0;
                var offset = 80;
                header.classList.add('headroom');

                function setState(state){
                    if (state === 'pinned') {
                        header.classList.add('headroom--pinned');
                        header.classList.remove('headroom--unpinned');
                    } else if (state === 'unpinned') {
                        header.classList.add('headroom--unpinned');
                        header.classList.remove('headroom--pinned');
                    }
                }

                function onScroll(data){
                    if (ticking) return;
                    ticking = true;
                    requestAnimationFrame(function(){
                        var y = data && typeof data.scroll === 'object' ? (data.scroll.y || 0) : 0;
                        var delta = y - lastY;
                        var absDelta = Math.abs(delta);

                        // Top/bottom states
                        var atTop = y <= 0;
                        header.classList.toggle('headroom--top', atTop);
                        header.classList.toggle('headroom--not-top', !atTop);

                        if (y < offset) {
                            // Before offset, keep pinned
                            setState('pinned');
                        } else {
                            if (delta > 0 && absDelta > toleranceDown) {
                                // Scrolling down
                                setState('unpinned');
                            } else if (delta < 0 && absDelta > toleranceUp) {
                                // Scrolling up
                                setState('pinned');
                            }
                        }

                        lastY = y;
                        ticking = false;
                    });
                }

                // Initial state
                setState('pinned');
                scroll.on('scroll', onScroll);
            }

            if (window.wsScroll) attachToScroll(window.wsScroll);
            window.addEventListener('ws:locomotive-ready', function(e){
                var s = e && e.detail && e.detail.scroll;
                attachToScroll(s || window.wsScroll);
            }, { once: true });
        } catch (e) {}
    })();

    // Preview selected images in Dodaj Nieruchomosc form: remove button, size, limit, submit via FormData when files present
    (function(){
        function formatBytes(bytes) {
            if (bytes === 0) return '0 MB';
            var mb = bytes / (1024 * 1024);
            return mb.toFixed(1).replace(/\.0$/, '') + ' MB';
        }

        function initPropertyUploadPreviews(context) {
            var root = context || document;
            var inputs = root.querySelectorAll('.dodaj-nieruchomosc__upload-input');
            if (!inputs || !inputs.length) return;

            Array.prototype.forEach.call(inputs, function(input){
                if (!input || input.dataset.wsUploadPreviewReady) return;
                input.dataset.wsUploadPreviewReady = '1';

                var inputId = input.id;
                if (!inputId) return;

                var form = input.closest('form');
                var preview = root.querySelector('[data-upload-preview-for="' + inputId + '"]');
                var sizeEl = root.querySelector('[data-upload-size-for="' + inputId + '"]');
                var limitMsgEl = root.querySelector('[data-upload-limit-msg-for="' + inputId + '"]');
                if (!preview) return;

                var maxBytes = form && form.getAttribute('data-max-upload-bytes') ? parseInt(form.getAttribute('data-max-upload-bytes'), 10) : 20 * 1024 * 1024;
                var maxLabel = form && form.getAttribute('data-max-upload-label') ? form.getAttribute('data-max-upload-label') : '20 MB';

                var filesArray = [];

                function totalSize() {
                    return filesArray.reduce(function(sum, f) { return sum + (f && f.size ? f.size : 0); }, 0);
                }

                function isOverLimit() {
                    return totalSize() > maxBytes;
                }

                function updateSizeAndLimit() {
                    if (!sizeEl) return;
                    var total = totalSize();
                    sizeEl.textContent = total > 0 ? 'Rozmiar: ' + formatBytes(total) + ' / ' + maxLabel : '';
                    sizeEl.classList.toggle('is-over', isOverLimit());
                    if (limitMsgEl) {
                        if (isOverLimit()) {
                            limitMsgEl.textContent = 'Przekroczono limit (' + maxLabel + '). Usuń część zdjęć.';
                            limitMsgEl.classList.add('is-over');
                        } else {
                            limitMsgEl.textContent = '';
                            limitMsgEl.classList.remove('is-over');
                        }
                    }
                }

                function renderPreviews() {
                    while (preview.firstChild) {
                        preview.removeChild(preview.firstChild);
                    }
                    filesArray.forEach(function(file, index){
                        if (!file || !file.type || file.type.indexOf('image/') !== 0) return;

                        var item = document.createElement('div');
                        item.className = 'dodaj-nieruchomosc__upload-preview-item';

                        var img = document.createElement('img');
                        img.className = 'dodaj-nieruchomosc__upload-preview-image';
                        img.alt = file.name || '';
                        item.appendChild(img);

                        var removeBtn = document.createElement('button');
                        removeBtn.type = 'button';
                        removeBtn.className = 'dodaj-nieruchomosc__upload-preview-remove';
                        removeBtn.setAttribute('aria-label', 'Usuń zdjęcie');
                        removeBtn.innerHTML = '&times;';
                        removeBtn.addEventListener('click', function(){
                            filesArray.splice(index, 1);
                            renderPreviews();
                            updateSizeAndLimit();
                            try { if (window.wsLocoUpdate) window.wsLocoUpdate(); } catch (e) {}
                        });
                        item.appendChild(removeBtn);

                        preview.appendChild(item);

                        try {
                            var reader = new FileReader();
                            reader.onload = function(ev){
                                img.src = ev.target && ev.target.result ? ev.target.result : '';
                            };
                            reader.readAsDataURL(file);
                        } catch (e) {}
                    });
                    updateSizeAndLimit();
                }

                input.addEventListener('change', function(){
                    var files = input.files ? Array.prototype.slice.call(input.files) : [];
                    filesArray = files.filter(function(f){ return f && f.type && f.type.indexOf('image/') === 0; });
                    input.value = '';
                    input.wsPropertyFiles = filesArray;
                    renderPreviews();
                    try { if (window.wsLocoUpdate) window.wsLocoUpdate(); } catch (e) {}
                });
                input.wsPropertyFiles = filesArray;

                function getConsentEl() {
                    return form ? form.querySelector('input[name="consent"]') : null;
                }
                function isConsentChecked() {
                    var consent = getConsentEl();
                    return consent && consent.checked;
                }
                function getRedirectUrl() {
                    var redirectInput = form.querySelector('input[name="_property_form_redirect"]');
                    var url = redirectInput && redirectInput.value ? redirectInput.value : window.location.href.split('?')[0];
                    return url.indexOf('?') >= 0 ? url : url;
                }
                function doSubmit(ev) {
                    if (ev) ev.preventDefault();
                    if (!isConsentChecked()) {
                        var consent = getConsentEl();
                        if (consent) {
                            consent.focus();
                            consent.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        }
                        return;
                    }
                    var files = input.wsPropertyFiles || filesArray;
                    var hasFiles = files && files.length > 0;
                    if (hasFiles && isOverLimit()) {
                        if (limitMsgEl) limitMsgEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                        return;
                    }
                    if (!hasFiles) {
                        form.submit();
                        return;
                    }
                    var formData = new FormData();
                    var els = form.elements;
                    for (var i = 0; i < els.length; i++) {
                        var el = els[i];
                        if (!el.name) continue;
                        if (el === input || (el.type === 'file' && el.id === inputId)) continue;
                        if (el.type === 'checkbox' || el.type === 'radio') {
                            if (el.checked) formData.append(el.name, el.value);
                        } else {
                            formData.append(el.name, el.value);
                        }
                    }
                    files.forEach(function(file){ formData.append('property_images[]', file); });

                    var submitBtn = form.querySelector('.dodaj-nieruchomosc__submit-button, button[type="submit"]');
                    if (submitBtn) {
                        submitBtn.style.pointerEvents = 'none';
                        submitBtn.setAttribute('aria-busy', 'true');
                    }
                    fetch(form.action, { method: 'POST', body: formData, redirect: 'follow' })
                        .then(function(res){
                            var goTo = (res && res.redirected && res.url) ? res.url : (getRedirectUrl() + (getRedirectUrl().indexOf('?') >= 0 ? '&' : '?') + 'formularz_status=success');
                            window.location.href = goTo;
                        })
                        .catch(function(){
                            if (submitBtn) {
                                submitBtn.style.pointerEvents = '';
                                submitBtn.removeAttribute('aria-busy');
                            }
                            var goTo = getRedirectUrl();
                            var sep = goTo.indexOf('?') >= 0 ? '&' : '?';
                            window.location.href = goTo + sep + 'formularz_status=error';
                        });
                }

                if (form && !form.dataset.wsPropertyFormSubmitReady) {
                    form.dataset.wsPropertyFormSubmitReady = '1';
                    var redirectInput = form.querySelector('input[name="_property_form_redirect"]');
                    if (redirectInput) redirectInput.value = window.location.href.split('?')[0];
                    form.addEventListener('submit', function(ev){
                        ev.preventDefault();
                        doSubmit(ev);
                    });
                    var submitBtn = form.querySelector('.dodaj-nieruchomosc__submit-button');
                    if (submitBtn) {
                        submitBtn.addEventListener('click', function(ev){
                            ev.preventDefault();
                            doSubmit(ev);
                        });
                    }
                }
            });
        }

        try { window.wsInitPropertyUploadPreviews = initPropertyUploadPreviews; } catch (e) {}
        initPropertyUploadPreviews(document);
    })();

    // Mobile menu toggle for primary navigation
    // Replaced by offcanvas burger menu

    function initModel3DSection(context) {
        var root = context || document;
        var els = root.querySelectorAll('.js-model3d-section__canvas');
        if (!els || !els.length) return;
        els.forEach(function(el){
            if (!el || el.dataset.model3dReady) return;
            el.dataset.model3dReady = '1';
            // Lazy import to avoid bundling heavy three.js into editor unnecessarily
            import(/* @vite-ignore */ './model3d-section.js').then(function(mod){
                if (mod && typeof mod.initModel3DSection === 'function') {
                    mod.initModel3DSection(el);
                }
            }).catch(function(){});
        });
    }

    try { window.wsInitModel3DSectionIn = initModel3DSection; } catch (e) {}
    // Ensure initialization runs even if the block view script fires earlier
    initModel3DSection(document);

    // Locomotive Scroll init
    (function(){
        try {
            var container = document.querySelector('[data-scroll-container]');
            if (!container || !window.LocomotiveScroll) return;

            var prefersReducedMotion = false;
            try {
                prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            } catch (e) {}
            var isTouch = (('ontouchstart' in window) || (navigator.maxTouchPoints && navigator.maxTouchPoints > 0));

            // Do not auto-add data-scroll-section; rely on native markup

            var viewportWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
            var treatAsDesktop = viewportWidth >= 1024;
            var useSmooth = !prefersReducedMotion && (treatAsDesktop || !isTouch);

            var scroll = new window.LocomotiveScroll({
                el: container,
                smooth: useSmooth,
                lerp: 0.08,
                smartphone: { smooth: false },
                tablet: { smooth: false }
            });

            try { window.wsScroll = scroll; } catch (e) {}
            try {
                window.dispatchEvent(new CustomEvent('ws:locomotive-ready', { detail: { scroll: scroll } }));
            } catch (e) {}

            // Remove initial lock class once Locomotive is ready
            try { document.documentElement.classList.remove('is-frontend'); } catch (e) {}

            // Update after images/fonts load
            window.addEventListener('load', function(){
                try { scroll.update(); } catch (e) {}
            });

            // Extra delayed refreshes to catch late layout shifts
            // try { setTimeout(function(){ scroll.update(); }, 120); } catch (e) {}
            // try { setTimeout(function(){ scroll.update(); }, 400); } catch (e) {}
            // try { setTimeout(function(){ scroll.update(); }, 1200); } catch (e) {}

            // Refresh on orientation changes
            window.addEventListener('orientationchange', function(){
                try { setTimeout(function(){ scroll.update(); }, 250); } catch (e) {}
            });

            // Refresh when webfonts are ready
            try {
                if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
                    document.fonts.ready.then(function(){ try { scroll.update(); } catch (e) {} });
                }
            } catch (e) {}

            // Refresh on image loads within the scroll container
            // try {
            //     var imgs = container.querySelectorAll('img');
            //     imgs.forEach(function(img){
            //         if (!img || img.complete) return;
            //         img.addEventListener('load', function(){
            //             try { if (window.wsLocoUpdate) window.wsLocoUpdate(); else scroll.update(); } catch (e) {}
            //         }, { once: true });
            //     });
            // } catch (e) {}

            // Observe DOM and size mutations to keep height in sync
            // try {
            //     if (typeof MutationObserver !== 'undefined') {
            //         var mo = new MutationObserver(function(){
            //             try { if (window.wsLocoUpdate) window.wsLocoUpdate(); else scroll.update(); } catch (e) {}
            //         });
            //         mo.observe(container, { childList: true, subtree: true });
            //     }
            // } catch (e) {}

            try {
                if (typeof ResizeObserver !== 'undefined') {
                    var ro = new ResizeObserver(function(){
                        try { if (window.wsLocoUpdate) window.wsLocoUpdate(); else scroll.update(); } catch (e) {}
                    });
                    ro.observe(container);
                }
            } catch (e) {}

            var resizeTimer;
            window.addEventListener('resize', function(){
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(function(){
                    try { scroll.update(); } catch (e) {}
                }, 200);
            });
        } catch (e) {}
    })();
});